import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const isMoviePage = location.pathname === '/movie';
  const isArtPage = location.pathname === '/art';
  const isTeamPage = location.pathname === '/team';

  const handleReturnHome = () => {
    navigate('/');
  };

  return (
    <footer className='relative bg-transparent z-[1000]'>
      {!isHomePage && (
        <div className='w-full m-0 p-0 relative'>
          <img
            src={process.env.PUBLIC_URL + '/footerimage.webp'}
            alt='Footer'
            className={`w-full h-auto m-0 p-0 ${isArtPage ? 'opacity-0' : ''} ${isMoviePage ? 'hidden md:block' : ''} ${isTeamPage ? '-mt-20' : ''}`}
          />
          <div className='absolute bottom-[30px] left-1/2 -translate-x-1/2 z-30'>
            <div
              className='flex flex-col items-center cursor-pointer hover:opacity-70'
              onClick={handleReturnHome}
            >
              <img
                src={
                  process.env.PUBLIC_URL +
                  '/Icon - Hand - LandingPage - F7EDDE.svg'
                }
                alt='Return Home'
                className='w-[60px] h-[60px] object-contain mb-[15px]'
              />
              <p className='text-[18px] text-[#F7EDDE] uppercase font-antelope-bold-caps'>
                CLICK TO RETURN HOME
              </p>
            </div>
          </div>
        </div>
      )}
      {isHomePage && (
        <div className='p-[20px_60px]'>
          <div className='flex justify-center md:justify-between items-center'>
            <div className='text-[11px] md:text-[16px] font-antelope-bold-caps text-center md:text-left'>
              Ocher 2026. All rights reserved.
            </div>
            <div className='flex items-center'>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;
